<div class="position-relative">
    <div *ngIf="createOrEditSalesRepInfo">
        <div class="container-fluid InfoForm thin-scroll">
            <div *ngFor="let salesRep of salesReps; let salesRepIndex = index">
                <div class="header p-3 my-2 d-flex align-items-center justify-content-between p-2">
                    <h6 *ngIf="salesRepIndex > 0"><span class="headertxt"> Sales Rep {{salesRepIndex}} : </span></h6>
                </div>

                <hr class="my-2" *ngIf="salesRepIndex > 0" />

                <div class="pr-3" *ngIf="salesRepIndex > 0">
                    <div class="row ml-1">
                        <app-contact class="w-100" [isCreateOrEdit]="createOrEditSalesRepInfo" [activeTab]="activeTab"
                            [currentTab]="currentTab" [salesRepIndex]="salesRepIndex"
                            [appTransactionsForViewDto]="appTransactionsForViewDto"
                            (updateAppTransactionsForViewDto)="onUpdateAppTransactionsForViewDto($event)"
                            (formValidityChanged)="isContactFormValid($event)"
                            [showDepartment]="activeTab == transactionCartoccordionTabs.BuyerContactInfo">
                        </app-contact>
                    </div>
                </div>

                <hr class="my-2" *ngIf="salesRepIndex > 0" />
            </div>

            <div class="d-flex justify-content-end mt-3 pr-3">
                <button *ngIf="!showSaveBtn && salesReps?.length" [disabled]="!isContactsValid"
                    (click)="createOrEditTransaction()" class="continuebtn text-center btn">
                    Continue
                </button>

                <button *ngIf="showSaveBtn" (click)="cancel" class="cancelbtn text-center btn ml-2">
                    Cancel
                </button>
                <button *ngIf="showSaveBtn" (click)="save()" [disabled]="!isContactsValid"
                    class="previewbtn text-center btn ml-2">
                    Save
                </button>
            </div>
        </div>

        <br />
        <button class="addbtn mr-3" (click)="addNewSalesRep()" *ngIf="salesReps?.length <= 2">
            Add <i class="fa fa-plus" style="color:#F88011"></i>
        </button>
        <br /><br />
    </div>

    <div *ngIf="!createOrEditSalesRepInfo">
        <app-view-sales-rep-info [activeTab]="activeTab" [currentTab]="currentTab"
            [appTransactionsForViewDto]="appTransactionsForViewDto"
            (showSalesRepEditMode)="onShowSalesRepEditMode($event)" (onshowSaveBtn)="onshowSaveBtn($event)"
            [createOrEditSalesRepInfo]="createOrEditSalesRepInfo" [canChange]="canChange"
            (isContactsValid)="isContactFormValid($event)">
        </app-view-sales-rep-info>
    </div>
</div>